import { HttpError, ResponseCode, WebResponse } from './http-client'
import { displayToast, ToastTypes } from '@logic'

const TOAST_DEDUP_WINDOW_MS = 30_000
const lastToastAt = new Map<string, number>()

function shouldShowToast(key: string): boolean {
  const now = Date.now()
  const prev = lastToastAt.get(key)
  if (prev && now - prev < TOAST_DEDUP_WINDOW_MS) return false
  lastToastAt.set(key, now)
  return true
}

export function getFriendlyErrorMessage(err: HttpError): string {
  if (err.status === ResponseCode.serverError) {
    return 'The server is having trouble. Please try again in a moment.'
  }
  if (err.status === ResponseCode.other && err.key === 'networkError') {
    return err.message || 'Unable to connect to the server.'
  }
  return err.message || 'Something Went Wrong'
}

export function dispatchErrorToast(message: string) {
  if (!shouldShowToast(message)) return
  ;(window as any).store.dispatch(displayToast(message, ToastTypes.error, message))
}

export function globalDisplayToast(type: ToastTypes, message: string) {
  ;(window as any).store.dispatch(displayToast(message, type, message))
}

export function displayErrorToast(message: string) {
  dispatchErrorToast(message)
}

export const accessDeniedWithFallback = <Response extends unknown>(accessDeniedResponse: Response) => <UnresolvedResponse extends unknown>(
  response: UnresolvedResponse
): Response => {
  if (response instanceof HttpError) {
    if (response.status == ResponseCode.accessDenied) {
      return accessDeniedResponse
    } else {
      dispatchErrorToast(getFriendlyErrorMessage(response))
      return {} as any // TODO: Make this stronger typed.  Will require a broader improvement of the error handling workflow.
    }
  } else {
    return response as Response
  }
}

export const whenAccessDenied = <T extends unknown>(response: WebResponse<T>): T | undefined => {
  if (response instanceof HttpError) {
    if (response.status == ResponseCode.accessDenied) {
      return undefined
    } else {
      dispatchErrorToast(getFriendlyErrorMessage(response))
      return undefined
    }
  } else {
    return response
  }
}
